<template>
  <div class="share">
    <div class="share-container container" v-if="!isFeedback">
      <div class="share-form-column">
        <h2 class="share-title">
          <span>Assine o </span>
          <span>manifesto para </span>
          <span>Impostos </span>
          <span>mais justos</span>
          para todos!
        </h2>

        <p>* Campos obrigatórios.</p>

        <div class="share-form">
          <div role="main" id="o-valor-do-seu-imposto-8bf13572a14ffdc340a4"></div>
        </div>

        <div class="post-content-share">
          <div style="width: 100%; display: block">
          <p style="margin: 0px; padding: 0px"><b>Gostou dessa ferramenta?</b></p> 
          <p style="margin: 0px; padding: 0px"><b>Compartilhe com seus amigos</b></p>
          </div>
          <ul>
            <li class="form-share__item">
              <a id="share-facebook" target="_blank" :href="'https://www.facebook.com/sharer/sharer.php?u='+ shareUrl">
                <svg class="post-content-share-icon"><use xlink:href="#icon-share--facebook" /></svg>
              </a>
            </li>
            <li class="form-share__item">
              <a id="share-twitter" target="_blank" :href="'http://twitter.com/share?url='+ shareUrl">
                <svg class="post-content-share-icon"><use xlink:href="#icon-share--twitter" /></svg>
              </a>
            </li>
            <li class="form-share__item">
              <a id="share-whatsapp" target="_blank" :href="'https://wa.me/?text='+ shareUrl">
                <svg class="post-content-share-icon"><use xlink:href="#icon-share--whatsapp" /></svg>
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div class="share-description-column">
        <div class="share-description-image">
          <img src="@/assets/images/share-view.jpg" />
          Crédito: André Teixeira/Oxfam Brasil
        </div>

        <div class="share-description-text">
          <h3>Cinco propostas tributárias para reduzir desigualdades</h3>
          <p>Nosso atual sistema de cobrança de impostos está aumentando as desigualdades sociais. Além de complexo e ineficiente, ele é injusto. Quem tem uma renda maior está contribuindo proporcionalmente menos do que tem uma renda menor.</p>
          <p>Precisamos de um sistema mais justo de tributação. Uma mudança é urgente!</p>
          <p>O debate sobre a reforma tributária no Congresso Nacional deve partir dos pontos fundamentais que estão gerando desigualdades, mas nem todas as propostas apresentadas tratam disso. Isso é um problema. A boa notícia é que você pode ajudar a mudar esse processo.</p>
          <p>Assine o Manifesto por impostos mais justos para todos. Levaremos as assinaturas para as comissões do Congresso Nacional que estão avaliando as propostas de reforma tributária.</p>
          <p>Defendemos cinco pontos essenciais:</p>
          <ul>
            <li>1. Simplificação e redução da tributação sobre o consumo.</li>
            <li>2. Equidade no imposto de renda pessoa física com o fim da isenção de lucros e dividendos e maior distribuição das faixas de renda e alíquotas para tributação.</li>
            <li>3. Equidade no imposto de renda pessoa jurídica para evitar que grandes empresas terminem pagando menos impostos que as pequenas e médias em razão do uso de diferentes regimes fiscais.</li>
            <li>4. Aplicação do ITR – o “IPTU rural” – nas suas funções social e de preservação ambiental, além da sua capacidade arrecadatória de grandes propriedades.</li>
            <li>5. Adoção do Imposto sobre Grandes Fortunas (IGF) sobre o 0.1% de pessoas com maior riqueza acumulada no país.</li>
          </ul>

          <button id="manifest" class="button-manifest" @click="openManifest">
            <svg class="button-manifest-icon">
              <use xlink:href="#icon-arrow--right" />
            </svg>

            Leia na íntegra
          </button>
        </div>
      </div>
    </div>

    <div class="share-feedback container" v-else>
      <div class="share-form-column">
        <h2 class="share-title">
          <span>Assinatura </span>
          <span>realizada</span>
          com sucesso
        </h2>

        <p>Você contribuiu para a mudança na cobrança de impostos no nosso país. Se você gostou da ferramenta, compartilhe com seus amigos e familiares, ou faça uma doação.</p>
        <p><b> Que tal apoiar a Oxfam Brasil na luta por uma sistema tributário mais justo?</b> </p>
        <a class="share-donation-button" href="https://doe.oxfam.org.br/calculadoraimposto" target="_blank">
          Com apenas R$10 você já pode 
        </a>

        <div class="post-content-share post-content-share--alternative">
          <b>Compartilhe</b>
          <ul>
            <li class="subscription-share__item">
              <a target="_blank" :href="'https://www.facebook.com/sharer/sharer.php?u='+ shareUrl">
                <svg class="post-content-share-icon"><use xlink:href="#icon-share--facebook" /></svg>
              </a>
            </li>
            <li class="subscription-share__item">
              <a target="_blank" :href="'http://twitter.com/share?url='+ shareUrl">
                <svg class="post-content-share-icon"><use xlink:href="#icon-share--twitter" /></svg>
              </a>
            </li>
            <li class="subscription-share__item">
              <a target="_blank" :href="'https://wa.me/?text='+ shareUrl">
                <svg class="post-content-share-icon"><use xlink:href="#icon-share--whatsapp" /></svg>
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div class="share-description-column">
        <div class="share-description-image">
          <img src="@/assets/images/result/feedback-image.jpg" />
          Crédito: André Teixeira/Oxfam Brasil
        </div>
      </div>
    </div>

    <div class="manifest-popup" @click="closeManifest">
      <div class="manifest-popup-container">
        <h2>CINCO PROPOSTAS TRIBUTÁRIAS PARA REDUZIR AS DESIGUALDADES</h2>
        <p><b>A forma como se cobra impostos pode aumentar ou reduzir desigualdades.</b> Isso vai depender
        da distribuição dos tributos sobre quatro grandes bases: renda, propriedade, consumo e
        contribuições sociais.</p>

        <p>Países que tributam mais a renda e a propriedade têm um sistema tributário mais progressivo,
        que cobra mais de quem tem mais. Assim funciona a maioria dos países mais desenvolvidos.
        Já aqueles que tributam mais o consumo tem um sistema tributário mais regressivo, em que se
        cobra mais, proporcionalmente, de quem tem menos. Isso concentra renda e aumenta as
        desigualdades. <b>Esse é o caso do Brasil.</b></p>

        <p>Apesar de a carga tributária brasileira estar na média do que se cobra de impostos em diversos
        países, ela está muito mal distribuída entre as quatro bases mencionadas. Enquanto 50% da
        arrecadação no Brasil é sobre consumo, a média nos países da OCDE (Organização para a
        Cooperação e o Desenvolvimento Econômico) é de 32%. Já a média da arrecadação sobre
        renda nos países da OCDE é de 34% enquanto no Brasil é de apenas 25%.</p>

        <p>Essa distorção tributária só faz aumentar as desigualdades existente no nosso país, levando a
        aumentar <b>o abismo entre a maioria da população e uma minoria privilegiada pelo atual
        sistema tributário.</b></p>

        <p>Além disso, a situação atual é um desrespeito à Constituição Federal, que diz que a cobrança
        de impostos no país tem que ser feita de acordo com a “capacidade econômica do
        contribuinte”. Ou seja: <b>quem tem mais recursos deve contribuir mais.</b></p>

        <p>Por isso, defendemos uma reforma tributária que <b>priorize a redução das desigualdades,</b> que
        <b>reequilibre a contribuição com impostos</b> no país e que reforce a <b>capacidade do Estado de
        oferecer serviços públicos de qualidade para todos e todas.</b> Para isso, <b>não é preciso
        aumentar a carga tributária do país! Basta redistribui-la.</b></p>

        <p>Existem diferentes propostas de reforma tributária em discussão hoje no Congresso Nacional.
        Algumas estão focadas em simplificar impostos e melhorar a eficiência do sistema, outras
        priorizam a redistribuição. <b>Simplificar e melhorar a eficiência do sistema</b> é importante e
        necessário, mas <b>não é suficiente.</b> Temos, como sociedade, o dever de ir mais além, com <b>uma
        reforma que enfrente as desigualdades, que seja justa e solidária.</b></p>

        <p>Como forma de contribuição ao debate, a Oxfam Brasil apresenta cinco propostas tributárias
        que deveriam ser priorizadas para uma reforma que gere um sistema tributário mais eficiente,
        simples, justo e que reduza as desigualdades.</p>

        <p><b>1. Simplificação da tributação sobre consumo – </b>O que chamamos de tributação sobre
        consumo é o que todas as pessoas pagam sobre bens e serviços consumidos. Essa tributação é
        alta e dispersa entre vários impostos e em diferentes níveis da federação. Uma consequência é
        que as pessoas que têm menor renda acabam pagando, proporcionalmente, mais imposto do
        que os que têm maior renda. Além disso, esse modelo gera ineficiências. É preciso simplificar
        criando um imposto sobre valor agregado (IVA) a partir da unificação de diferentes impostos
        como Cofins, PIS/Pasep, IPI, ICMS e ISS. E um imposto seletivo (IS) sobre produtos que geram
        externalidades negativas, como cigarro, agrotóxicos, carbono, bebidas açucaradas.</p>

        <p><b>Mas, uma reforma tributária que só simplifique a tributação sobre o consumo não é
        suficiente para reduzir desigualdades.</b> Também é necessário fazer uma redistribuição da carga
        tributária do consumo para renda e patrimônio, como acontece nos países mais
        desenvolvidos.</p>

        <p><b>2. Equidade no Imposto de Renda Pessoa Física (IRPF) – </b>As alíquotas do IRPF são muito
        concentradas nas rendas médias, o que limita a progressividade desse tipo de imposto. Além
        disso, o que as pessoas ganham com lucros e dividendos não é taxado, reduzindo ainda mais a
        contribuição das rendas mais altas. Isso significa que a classe média, em geral, paga
        proporcionalmente mais IRPF que muitos milionários. É preciso ajustar a tabela de alíquotas
        do IRPF para garantir a progressividade para as faixas mais altas, além de estabelecer o
        imposto sobre lucros e dividendos.</p>

        <p><b>3. Equidade no Imposto de Renda Pessoa Jurídica (IRPJ) – </b>O atual sistema permite que as
        empresas com maior faturamento possam pagar menos impostos que as médias e pequenas
        empresas. Isso pode ocorrer porque cada uma tem um regime diferente de tributação.
        Enquanto as pequenas e médias empresas contribuem sobre um valor mais fixo, as grandes
        corporações pagam sobre um lucro real, que elas conseguem reduzir muito, por estratégias ou
        brechas. É essencial conter essas possibilidades de redução da tributação das grandes
        empresas.</p>

        <p><b>4. Efetivação do Imposto sobre a Propriedade Territorial Rural (ITR) – </b>É cobrado a partir do
        tamanho e utilização que os proprietários de terras declaram em relação às suas propriedades.
        Essa auto-declaração pode gerar sonegação e reduzir a arrecadação. Esse imposto não deve
        ser “auto declaratório”. É preciso fortalecer o cadastramento rural e ter uma fiscalização
        intensa. Além disso, é essencial resgatar os objetivos do ITR que se referem à função social da
        terra e à preservação ambiental, usando melhor os critérios tanto da utilização da terra como
        da área não tributável para o seu cálculo.</p>

        <p><b>5. Regulamentação do Imposto sobre Grandes Fortunas (IGF) – </b>Está previsto no inciso VII do
        artigo 153 da Constituição Federal, mas nunca foi regulamentado. Esse é um imposto que
        somente uma pequena parcela da população com uma renda muito alta contribuiria e não
        teria impacto na maioria da população. O IGF deve partir de três pontos estruturais: começar
        no topo da pirâmide, ou seja, focado no 0,1% que tem a maior renda no país; tributar todos os
        ativos; estabelecer regras mais rígidas contra sonegação.</p>

        <button class="manifest-popup-close" @click="closeManifest">
          <svg class="manifest-popup-icon"><use xlink:href="#icon-close" /></svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import IMask from 'imask';
import VMasker from 'vanilla-masker'

export default {
  data(){
    return {
      name: '',
      email: '',
      phone: '',
      birthday: '',
      newsletter: '',
      isFeedback: false
    }
  },
  mounted() {
    window.alert = (msg) => {
      if (msg == 'Obrigado!') {
        this.$router.push({
          path: '/obrigado'
        });
        this.isFeedback = true;
      } else {
        this.isFeedback = false;
        this.setScroll();
      }
    }

    if (this.$route.path == '/obrigado') {
      this.isFeedback = true;
    } else {
      new RDStationForms('o-valor-do-seu-imposto-8bf13572a14ffdc340a4-html', 'UA-38708408-1').createForm();

      setTimeout(() => {
        /*console.log("TESTE", document.querySelector('#rd-phone_field-16CfVE2yxrHnnuryzANUkw'))
        let telMask = ['(99) 9999-99999', '(99) 99999-9999'];
        let tel = document.getElementById('rd-phone_field-16CfVE2yxrHnnuryzANUkw')
        VMasker(tel).maskPattern(telMask[0]);
        tel.addEventListener('input', this.inputHandler.bind(undefined, telMask, 14), false);*/

        let maskIdade = ['999'] 
        let idade = document.getElementsByClassName('js-field-cf_idade')
        
        VMasker(idade).maskPattern(maskIdade[0]);

        let inputTell = document.getElementsByClassName('js-phone')

        inputTell[0].maxLength = 20;

        //VMasker(inputTell).maskPattern(maskTell[0]);

        // 


        let textoPolitica = document.getElementById('rd-static_text-knombug0')

        textoPolitica.innerHTML = "Ao informar os seus dados, você declara que leu a <a target='_blank' href='https://www.oxfam.org.br/politica-de-privacidade/?_ga=2.227638485.937008516.1617664427-1960657114.1617234060'>Política de Privacidade</a> da Oxfam Brasil e que está ciente do seu conteúdo."

        
       
      }, 3000);
    }
  },
  computed: {
    shareUrl() {
      return window.location.href;
    },
  },
  methods: {
    inputHandler(masks, max, event) {
      let c = event.target;
      let v = c.value.replace(/\D/g, '');
      let m = c.value.length > max ? 1 : 0;
      VMasker(c).unMask();
      VMasker(c).maskPattern(masks[m]);
      c.value = VMasker.toPattern(v, masks[m]);
    },
    openManifest(){
      this.$store.dispatch('share/open');
    },
    closeManifest(event){
      event.stopPropagation();
      
      this.$store.dispatch('share/close');
    },
    setScroll(){
      event.preventDefault();

      const offsetTop = document.querySelector('.share').offsetTop - 104;

      window.scrollTo(0, offsetTop)
    }
  }
};
</script>

<style lang="scss">
#conversion-o-valor-do-seu-imposto-8bf13572a14ffdc340a4 {
  section {
    margin-left: rem-calc(-20) !important;
    margin-right: rem-calc(-20) !important;

    form {
      div.field {
        position: relative !important;
        padding-bottom: rem-calc(25) !important;
      }

      label {
        position: absolute !important;
        top: rem-calc(-13) !important;
        left: rem-calc(30) !important;

        padding: rem-calc(0 5) !important;

        font-size: rem-calc(14) !important;
        line-height: rem-calc(24) !important;

        background-color: $white !important;
      }

      input.form-control {
        padding-top: rem-calc(20) !important;
        padding-left: rem-calc(30) !important;
        padding-right: rem-calc(30) !important;
        padding-bottom: rem-calc(20) !important;

        border-radius: rem-calc(30) !important;
        border-width: 2px !important;
        border-style: solid !important;
        border-color: rgba(#7a7a7a, 0.7) !important;

        &:-webkit-autofill,
        &:-webkit-autofill:hover,
        &:-webkit-autofill:focus,
        &:-webkit-autofill:active {
          transition: background-color 9999s ease-out;
          transition-delay: 9999s;
        }
      }

      input[type=submit].call_button {
        padding-top: rem-calc(15) !important;
        padding-left: rem-calc(30) !important;
        padding-right: rem-calc(30) !important;
        padding-bottom: rem-calc(15) !important;

        border-radius: rem-calc(30) !important;
        border-width: 0px !important;

        &:-webkit-autofill,
        &:-webkit-autofill:hover,
        &:-webkit-autofill:focus,
        &:-webkit-autofill:active {
          transition: background-color 9999s ease-out;
          transition-delay: 9999s;
        }
      }
    }
  }
}

.share {
  width: 100%;
  padding: rem-calc(100 0 65 0);

  @media #{$large-up} {
    padding: rem-calc(120 0 65 0);
  }

  .post-content-share {
    position: relative;

    width: 100%;
    max-width: rem-calc(980);

    @media #{$medium-up} {
      margin-bottom: rem-calc(30);
    }

    b {
      display: block;
      margin-bottom: rem-calc(10);

      color: $boulder;
      font-size: rem-calc(16);
      font-weight: normal;
      line-height: rem-calc(25);
    }

    ul {
      display: flex;
    }

    li {
      max-width: rem-calc(25);
      max-height: rem-calc(25);

      margin-right: rem-calc(15);
    }

    svg {
      width: rem-calc(25);
      height: rem-calc(25);
    }
  }
}

.share-container,
.share-feedback {
  @media #{$large-up} {
    display: flex;
  }
}

.share-container {
  display: flex;
  flex-direction: column-reverse;

  @media #{$medium-up} {
    flex-direction: row;
  }
}

.share-feedback {
  .share-form-column {
    @media #{$xlarge-up} {
      margin-right: rem-calc(75);
    }

    p {
      font-size: rem-calc(16);
    }
  }

  .share-description-image {
    text-align: right;
  }
}

.share-form-column {
  width: 100%;
  max-width: rem-calc(355);

  flex-shrink: 0;
  margin: 0 auto;

  @media #{$medium-up} {
    margin: 0 auto 60px;
  }

  @media #{$large-up} {
    margin-right: rem-calc(40);
  }

  @media #{$xlarge-up} {
    margin-right: rem-calc(120);
  }

  p {
    margin-top: 0;
    margin-bottom: rem-calc(20);

    font-size: rem-calc(14);
    line-height: rem-calc(24);

    opacity: 0.7;
  }

  form {
    display: block;
  }
}

.share-title {
  margin: rem-calc(0 0 20 0);

  color: $turmeric;
  font-family: $font-family--header;
  font-size: rem-calc(40);
  line-height: rem-calc(45);

  span {
    display: block;
  }
}

#o-valor-do-seu-imposto-8bf13572a14ffdc340a4-html {
  position: relative;

  margin-bottom: rem-calc(30);

  label {
    position: absolute;
    top: rem-calc(-10);
    left: rem-calc(30);

    padding: rem-calc(0 5);

    font-size: rem-calc(14);
    line-height: rem-calc(24);

    background-color: $white;
  }

  input {
    width: 100%;
    padding: rem-calc(15 30);

    border-radius: rem-calc(30);
    border: 2px solid rgba(#7a7a7a, 0.7);

    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus,
    &:-webkit-autofill:active {
      transition: background-color 9999s ease-out;
      transition-delay: 9999s;
    }
  }
}

.form-checkbox {
  position: relative;

  display: flex;
  align-items: center;

  font-size: rem-calc(14);
  line-height: rem-calc(14);

  input {
    display: none;
  }

  span {
    display: block;
    margin-right: rem-calc(10);

    width: rem-calc(28);
    height: rem-calc(28);

    border-radius: 100%;
    border: 1px solid rgba(#7a7a7a, 0.7);
    background-position: center center;
    background-repeat: no-repeat;
  }

  input:checked ~ span {
    background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='12px' height='10px' viewBox='0 0 12 10' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: sketchtool 58 (101010) - https://sketch.com --%3E%3Ctitle%3EFCA96A5E-CE6D-48FA-ABE1-5EAC672D943C%3C/title%3E%3Cdesc%3ECreated with sketchtool.%3C/desc%3E%3Cg id='Layout' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='0.1-Calculadora' transform='translate(-174.000000, -3003.000000)' fill='%2353297D'%3E%3Cg id='Group-12' transform='translate(165.000000, 2488.000000)'%3E%3Cg id='Icone/Checked-Fill' transform='translate(9.000000, 515.000000)'%3E%3Cpath d='M2.27874808,3.81270157 C1.75267291,3.2806049 0.90522399,3.28622749 0.385917927,3.82525998 C-0.133388137,4.36429248 -0.127900699,5.23261423 0.398174463,5.7647109 L3.7991443,9.20460857 C4.35865474,9.77052323 5.27144093,9.72278848 5.77181212,9.10144662 L11.2939162,2.24430841 C11.7643862,1.66009676 11.6835647,0.795714654 11.1133964,0.313656931 C10.5432281,-0.168400792 9.69962416,-0.0855886753 9.22915421,0.49862297 L4.63834856,6.19931027 L2.27874808,3.81270157 Z' id='Checklist-2'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  }
}

.form-button,
.share-donation-button {
  display: inline-block;

  width: 100%;

  margin-bottom: rem-calc(35);
  padding: rem-calc(15 30);

  color: $white;
  font-size: rem-calc(16);
  text-align: center;
  font-weight: bold;
  line-height: rem-calc(24);
  letter-spacing: 1px;

  border: 0;
  border-radius: rem-calc(30);
  background-color: $minsk;
  
  cursor: pointer;
  outline: 0;
}

a.share-donation-button {
  color: $white !important;
  text-decoration: none !important;
}

.share-description-column {
  width: 100%;
}

.share-description-image {
  margin-bottom: rem-calc(30);

  img {
    width: 100%;
    margin-bottom: 5px;
  }
}

.share-description-text {
  margin-bottom: rem-calc(30);

  @media #{$medium-up} {
    margin-bottom: 0;
  }

  @media screen and (min-width: 640px) {
    column-count: 2;
    column-gap: 25px;
  }

  h3 {
    margin: rem-calc(0 0 25 0);

    color: $turmeric;
    font-family: $font-family--header;
    font-size: rem-calc(22);
    line-height: rem-calc(30);
  }

  p,
  ul {
    font-size: rem-calc(16);
    line-height: 1.5;
  }

  p {
    margin: rem-calc(0 0 20 0);
  }

  ul {
    margin-bottom: rem-calc(20);

    li + li {
      margin-top: rem-calc(20);
    }
  }
}

.button-manifest {
  display: flex;
  align-items: center;
  justify-content: center;

  background-color: $white;
  border: 2px solid $minsk;
  border-radius: 30px;
  
  width: rem-calc(260);
  height: rem-calc(50);
  
  color: $minsk;
  font-size: rem-calc(14);
  font-weight: bold;

  cursor: pointer;
  outline: 0;
}

.button-manifest-icon {
  width: rem-calc(28);
  height: rem-calc(21);
  margin-right: rem-calc(10);
}

.post-content-share--alternative {
  position: relative;
  display: block;

  width: 100%;
  max-width: rem-calc(980);
  margin-bottom: rem-calc(20);

  b {
    display: block;
    margin-bottom: rem-calc(20);

    color: $boulder;
    font-size: rem-calc(22);
    font-family: $font-family--header;
    font-weight: normal;

    line-height: rem-calc(25);
    text-align: left;
  }

  ul {
    display: flex;
  }

  li {
    max-width: rem-calc(40);
    max-height: rem-calc(40);
    margin-right: rem-calc(15);
  }

  svg {
    width: 100%;
    height: 100%;
  }
}

.manifest-popup {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;

  width: 100vw;
  height: 100vh;
  
  background-color: rgba(0, 10, 18, 0.39);
  
  opacity: 0;
  overflow-y: scroll;
  pointer-events: none;

  transition: opacity .3s;

  @media #{$medium-up} {
    
  }

  .has-manifest & {
    opacity: 1;
    pointer-events: auto;
  }
}

.manifest-popup-container {
  position: relative;

  width: rem-calc(800);
  max-width: 100%;

  margin: rem-calc(30) auto;
  padding: rem-calc(50 30 30);
  
  background-color: $white;

  @media #{$medium-up} {
    padding: rem-calc(70);
  }

  h2 {
    color: $turmeric;
    font-family: $font-family--header;
    font-size: rem-calc(40);
    margin-bottom: rem-calc(40);
  }

  p + h3 {
    margin-top: rem-calc(30);
  }

  h3 {
    margin-bottom: rem-calc(10);
    font-size: rem-calc(24);
  }
}

.manifest-popup-close {
  position: absolute;
  top: rem-calc(40);
  right: rem-calc(25);

  width: rem-calc(24);
  height: rem-calc(23);

  margin: 0;
  padding: 0;

  background-color: transparent;
  border: 0;
  
  cursor: pointer;
  outline: 0;

  svg {
    width: 100%;
    height: 100%;
  }
}


input[type=checkbox] {
  -webkit-appearance: auto !important;

}


  /* Chrome, Safari, Edge, Opera */
.js-field-cf_idade::-webkit-outer-spin-button,
.js-field-cf_idade::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
.js-field-cf_idade {
  -moz-appearance: textfield;
}

</style>
